import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Clock, AlertCircle, CheckCircle2, HelpCircle } from 'lucide-react';

const HandlingDelays = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/processing-times')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Processing Times
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            What to Do If Processing is Delayed
          </h1>
          <p className="text-muted-foreground">
            Guidelines and solutions for handling delays in your residence permit application process.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Clock className="h-5 w-5 text-primary mr-2" />
                Understanding Delays
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Common Causes:</span> High application volume, incomplete documentation, additional verification needed
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Legal Timeframes:</span> Standard processing should take 60 days but often extends longer
                  </div>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Your Rights:</span> You can stay and work in Poland while your application is being processed
                  </div>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <HelpCircle className="h-5 w-5 text-primary mr-2" />
                What You Can Do
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Regularly check your application status online
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Contact your case inspector for updates
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Submit any requested additional documents promptly
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Consider seeking legal assistance
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Legal Options
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  File a complaint about inaction (after legal processing time)
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Request written confirmation of your application status
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Appeal to the Head of the Office for Foreigners
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Seek assistance from an ombudsman
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Experiencing Significant Delays?</h2>
            <p className="text-muted-foreground mb-4">
              Our legal team can help you understand your options and take appropriate action to address processing delays.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Get Legal Support
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandlingDelays; 